import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const unitOverdueReminder = createAsyncThunk("duesByUnit/overdueReminder", async ({ data, navigate }) => {
    try {
        const res = await axios({
            method: "POST",
            url: getConfig.API_URL + "unit_overdue_reminder",
            data: {
                premise_id: data?.premise_id,
                unit_id: data?.unit_id,
                reminder_remark: data?.reminder_remark,
                reminder_type: data?.reminder_type,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const duesByUnit = createAsyncThunk("duesByUnit/list", async ({ params, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + "dues_by_unit",
            params: {
                premise_id: params?.premise_id,
                ...(params?.month != null && params.month !== '' && { month: params.month }),
                ...(params?.paid != null && { paid: params.paid }),
                ...(params?.due != null && { due: params.due }),
                ...(params?.overdue != null && { overdue: params.overdue }),
                ...(params?.count != null && { count: params.count }),
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const duesByUnitSlice = createSlice({
    name: "duesByUnit",
    initialState: {
        list: [],
        summary: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(duesByUnit.pending, (state) => {
            state.loading = true
        })
        builder.addCase(duesByUnit.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                const data = action.payload.data.data
                if (action.meta.arg.params?.count) {
                    state.summary = data
                    state.list = []
                } else {
                    state.list = Array.isArray(data) ? data : (data?.list ?? [])
                    state.summary = state.summary
                }
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
                state.list = []
                state.summary = null
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                if (action.meta.arg.params?.count) {
                    state.summary = null
                } else {
                    state.list = []
                }
            }
        })
        builder.addCase(duesByUnit.rejected, (state) => {
            state.loading = false
        })
    },
})

export default duesByUnitSlice.reducer
